export const SECOND = 1000; // ms
export const MINUTE = 60 * SECOND;
export const HOUR   = 60 * MINUTE;
export const DAY    = 24 * HOUR;
export const WEEK   = 7 * DAY;

/**
 * Multiply base time units by a given number.
 */
export const SECONDS = (times: number = 1): number => times * SECOND;
export const MINUTES = (times: number = 1): number => times * MINUTE;
export const HOURS   = (times: number = 1): number => times * HOUR;
export const DAYS    = (times: number = 1): number => times * DAY;
export const WEEKS   = (times: number = 1): number => times * WEEK;
